import dayjs from "dayjs";

export function formatEventDateParts(date: number) {
	const d = dayjs(date);

	return {
		weekday: d.format('dddd'),
		day: d.format('D'),
		month: d.format('MMMM'),
		year: d.format('YYYY'),
	};
}

export function formatEventDateLong(
	date: number,
	template: string,
) {
	const parts = formatEventDateParts(date);

	return template
		.replace('{weekday}', capitalize(parts.weekday))
		.replace('{day}', parts.day)
		.replace('{month}', parts.month)
		.replace('{year}', parts.year);
}

function capitalize(value: string) {
	return value.charAt(0).toUpperCase() + value.slice(1);
}

function formatHourMinutes(ts: number) {
	return {
		hour: dayjs(ts).format('HH'),
		minutes: dayjs(ts).format('mm'),
	};
}

export function formatEventTimeRange(
	startDate: number,
	endDate: number,
	timeSeparator: string,
) {
	const start = formatHourMinutes(startDate);
	const end = formatHourMinutes(endDate);

	return (
		`${start.hour}${timeSeparator}${start.minutes}` +
		` - ` +
		`${end.hour}${timeSeparator}${end.minutes}`
	);
}